const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const paramsSchema = z.object({
  roadmapId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});